// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"19a43a63","670":"81bc59fb"}[chunkId] + ".chunk.css";
};